<template>
  <div>
    <Head title="operators" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/settings">Settings</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Operators</li>
      </ol>
    </nav>
    <h1>Operators</h1>

    <div class="d-flex justify-content-between mb-3">
      <search-filter v-model="form.search" @reset="reset" />

      <Link class="btn btn-primary" href="/settings/operators/create">
        <span>Create Operator</span>
      </Link>
    </div>

    <div class="content-box">
      <table class="table">
        <thead>
          <tr>
            <th>Operator Name</th>
            <th>Code</th>
            <th>Contact Name</th>
            <th>Contact Phone</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="operator in operators.data" :key="operator.id">
            <td>
              <Link :href="`/settings/operators/${operator.id}/edit`">
                {{ operator.name }}
              </Link>
            </td>
            <td>
              <Link :href="`/settings/operators/${operator.id}/edit`" tabindex="-1">
                {{ operator.code }}
              </Link>
            </td>
            <td>
              <Link :href="`/settings/operators/${operator.id}/edit`" tabindex="-1">
                {{ operator.contact_name }}
              </Link>
            </td>
            <td>
              <Link :href="`/settings/operators/${operator.id}/edit`" tabindex="-1">
                {{ operator.contact_phone }}
              </Link>
            </td>
          </tr>
          <tr v-if="operators.length === 0">
            <td colspan="2">No operators found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-3" :links="operators.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    operators: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/settings/operators', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
